import { render } from "./Home.vue?vue&type=template&id=8892ebd6&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=8892ebd6&scoped=scoped&lang=css"
import "./Home.vue?vue&type=style&index=1&id=8892ebd6&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8892ebd6"]])

export default __exports__